import { type INotificationToastProps } from '@cuemath/leap';

export const ACTIONS = {
  SHOW_TOAST_MESSAGE: 'SHOW_TOAST_MESSAGE',
  HIDE_TOAST_MESSAGE: 'HIDE_TOAST_MESSAGE',
} as const;

type TNotificationToastData = {
  message: INotificationToastProps['message'];
  ctaList: INotificationToastProps['ctaList'] | null;
  timeout?: INotificationToastProps['timeout'] | null;
  toastMetaData?: INotificationToastProps['toastMetaData'] | null;
};

export const showToast = (
  message: TNotificationToastData['message'],
  ctaList: INotificationToastProps['ctaList'] | null,
  timeout?: TNotificationToastData['timeout'],
  toastMetaData?: TNotificationToastData['toastMetaData'],
) => ({
  type: ACTIONS.SHOW_TOAST_MESSAGE,
  payload: {
    message,
    ctaList,
    timeout,
    toastMetaData,
  },
});

export const hideToast = () => ({
  type: ACTIONS.HIDE_TOAST_MESSAGE,
});
